import { createContext, useContext } from "react";
var ServiceIdContext = createContext("");
export var ServiceIdContextProvider = ServiceIdContext.Provider;
export var useServiceId = function () { return useContext(ServiceIdContext); };
